import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const NextEpisodeFillContainer = styled.div<Props>`
  background: ${(props) =>
    props.focused ? Colors['progress']['fillNextEpisode'] : 'none'};
  bottom: ${60 * Screen.widthRatio}px;
  height: 100%;
  position: relative;
  transition: width 1s linear;
  width: ${(props) => props.fill || 0}%;
  z-index: -1;
`;

export default NextEpisodeFillContainer;
